import { z } from 'zod';
import { idSchema } from './common.js';
import { customFieldDefinitionSchema } from './custom-field.js';
import { supportedLocaleSchema } from './plm-material.js';
export const customFieldRecordParamsSchema = z.object({
    entityType: z.enum(['CUSTOMER', 'PRODUCT']),
    recordId: idSchema,
});
export const customFieldRecordQuerySchema = z.object({
    locale: supportedLocaleSchema.optional(),
});
export const customFieldRecordAvailabilitySchema = z.object({
    definitionId: idSchema,
    key: z.string().min(1).max(50),
    unpublished: z.boolean(),
    unresolvedSourceValue: z.string().nullable(),
});
/** Record availability never changes a definition's publication status or global applicability. */
export const customFieldRecordContextSchema = customFieldRecordParamsSchema.extend({
    definitions: z.array(customFieldDefinitionSchema),
    availability: z.array(customFieldRecordAvailabilitySchema),
});
//# sourceMappingURL=custom-field-record.js.map